module.exports = __webpack_public_path__ + "static/media/배너 이용 방법 1.bf6bc176.jpg";